<template>
    <div v-if="area" class="area">
        <textarea
            v-for="lang in langs"
            :key="lang.id"
            :value="value[lang.value]"
            @blur="e => updateLang(lang.value, e.target.value)"
            type="text"
            :placeholder="lang.label"
        />
    </div>
    <div v-else>
        <input
            v-for="lang in langs"
            :key="lang.id"
            :value="value[lang.value]"
            @blur="e => updateLang(lang.value, e.target.value)"
            type="text"
            :placeholder="lang.label"
        />
    </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
    props: {
        value: {
            type: Object,
            required: true
        },
        area: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapGetters("i18n", {
            locale: "getLocale",
            langs: "getLangs"
        })
    },
    methods: {
        updateLang(langId, value) {
            const newValue = {};
            for (const lang of this.langs) {
                newValue[lang.value] = lang.value === langId ? value.trim() : this.value[lang.value] || "";
            }
            this.$emit("input", newValue);
        }
    }
};
</script>

<style lang="scss" scoped>
div {
    display: grid;
    grid-template-columns: auto auto;
    grid-column-gap: 5px;
    grid-row-gap: 5px;
    align-items: start;

    &.area {
        grid-template-columns: 1fr;
        textarea {
            width: 100%;
        }
    }
}

textarea {
    resize: vertical;
}
</style>



// WEBPACK FOOTER //
// translation-input.vue?66fefd0a